// ========================================
// ================== V3 ==================
// ========================================

import * as aTypes from "./actionTypes";

// ============ MY USERS  ============

export const initFetchMyUsers = () => {
  return {
    type: aTypes.V3_MY_USERS_INIT,
  };
};

export const fetchMyUsersSuccess = (myUsers) => {
  return {
    type: aTypes.V3_MY_USERS_SET,
    myUsers: myUsers,
  };
};

export const fetchMyUsersFail = (error) => {
  return {
    type: aTypes.V3_MY_USERS_FETCH_FAIL,
    error: error,
  };
};
